import CompetitionPanel from './CompetitionPanel';

export default CompetitionPanel;
